import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogClose } from '@angular/material/dialog';
import { PlannedPurpose } from 'src/app/core/models/purpose';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { PlanningTableComponent } from '../../planning-table/planning-table.component';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-actions-and-kpi-list',
    styles: [
        ':host { display: block; min-width: 700px;}',
    ],
    template: `
    <h4 mat-dialog-title class="text-center mb-2">Attenzione! Stai eliminando una finalità di beneficio comune</h4>
    <p class="mb-4 text-center">Questa finalità di beneficio comune così come le azioni e gli obiettivi associati non saranno più disponibili nella sezione pianificazione.</p>

    @if (data.currentPlannedPurpose) {
      <section mat-dialog-content class="mb-4">
        <h4 class="text-center">L'eliminazione avverrà dall'anno corrente. Le finalità, azioni e obiettivi passati non verranno modificati.</h4>
        <app-planning-table [selectedBenefitId]="data.currentPlannedPurpose._id" [plannedPurposes]="[data.currentPlannedPurpose]" [readOnly]="true">
        </app-planning-table>
      </section>
    }

    @if (data.nextPlannedPurpose) {
      <section mat-dialog-content class="mb-4" id="table">
        <h4 class="text-center">Next year</h4>
        <app-planning-table [selectedBenefitId]="data.nextPlannedPurpose._id" [plannedPurposes]="[data.nextPlannedPurpose]" [readOnly]="true">
        </app-planning-table>
      </section>
    }

    <section class="d-flex justify-content-center">
      <button mat-flat-button [mat-dialog-close]="false">Annulla</button>
      <button mat-flat-button color="warn" [mat-dialog-close]="true" class="ms-3">Conferma</button>
    </section>
    `,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, PlanningTableComponent, MatButton, MatDialogClose]
})
export class ActionsAndKpiListComponent {
  data = inject<{
    currentPlannedPurpose?: PlannedPurpose;
    nextPlannedPurpose?: PlannedPurpose;
}>(MAT_DIALOG_DATA);

}
